module.exports = __webpack_public_path__ + "img/serviceb.854e5a5d.png";